import * as React from "react";

export default function DefaultIcon(props: React.PropsWithChildren<{}>) {
	return (
		<svg {...props} x="0" y="0" viewBox="0 0 100 100" fill="currentColor">
			<path d="M0 0 L100 0 L100 100 L0 100 Z" />
		</svg>
	);
}
